'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import emptyFunction from 'react-utils/emptyFunction';
import UIButton from 'UIComponents/button/UIButton';

const PracticalExerciseStartButton = ({
  exerciseLocation,
  isExternal,
  onStartClick,
  use,
  label
}) => {
  const history = useHistory();
  const handleOpenModal = useCallback(() => {
    onStartClick();
    history.push(exerciseLocation);
  }, [onStartClick, history, exerciseLocation]);
  return /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "practical-exercise-start-button",
      href: isExternal ? undefined : exerciseLocation,
      onClick: isExternal ? handleOpenModal : onStartClick,
      use: use,
      children: label
    })
  });
};

PracticalExerciseStartButton.propTypes = {
  exerciseLocation: PropTypes.string.isRequired,
  isExternal: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onStartClick: PropTypes.func,
  use: PropTypes.string
};
PracticalExerciseStartButton.defaultProps = {
  isExternal: false,
  onStartClick: emptyFunction,
  use: 'primary'
};
export default PracticalExerciseStartButton;